<template>
    <v-content>
        <v-row class="pb-0 pb-sm-10">
            <v-col class="display-1">
                Триггеры
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="create()">
                        <v-icon small>mdi-plus</v-icon>
                        Добавить
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-data-table :headers="headers" :items="triggers" sort-by="id" class="elevation-4">
            <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>Редактировать</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                    <span>Удалить</span>
                </v-tooltip>
            </template>

            <template v-slot:item.enableAction="{ item }">
                <v-switch v-model="item.enabled" @change="switchTrigger(item)"></v-switch>
            </template>
        </v-data-table>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
export default {
    name: "TriggersTable",
    data() {
        return {
            filters: {},
            headers: [
                { text: "Включен", value: "enableAction", sortable: false },
                { text: "ID", align: "start", sortable: true, value: "id" },
                { text: "Событие", sortable: false, value: "eventFormatted" },
                { text: "Описание", sortable: false, value: "descriptionFormatted" },
                { text: "Тип", sortable: false, value: "typeFormatted" },
                { text: "Тип контента", sortable: false, value: "contentFormatted" },
                { text: "Задержка", sortable: false, value: "delayFormatted" },
                { text: "Действия", value: "actions", sortable: false },
            ],
        };
    },
    components: {
        OverlayLoader,
    },
    created() {
        this.$store.dispatch("FETCH_TRIGGERS", this.filters);
    },
    computed: {
        triggers() {
            return this.$store.getters.TRIGGERS_LIST;
        },
        isLoading() {
            return this.$store.getters.TRIGGERS_LIST_LOADING;
        },
    },
    methods: {
        editItem(trigger) {
            this.$router.push({ name: "TriggerUpdate", params: { id: trigger.id } });
        },
        deleteItem(trigger) {
            this.$store
                .dispatch("DELETE_TRIGGER", trigger)
                .then(() => this.$store.dispatch("FETCH_TRIGGERS", this.filters));
        },
        create() {
            this.$router.push({ name: "TriggerCreate" });
        },
        switchTrigger(trigger) {
            this.$store.dispatch("SWITCH_TRIGGER", { trigger, isEnabled: trigger.enabled });
        },
    },
};
</script>
